import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AdminLLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M64 272L1216 67v1914L64 1782V272zm398 1122l391 22-3-143-256-4V626l-132 16v752zm944-369q0 26-10 49t-27 40-40 27-49 10V898q26 0 49 10t40 27 27 41 10 49zm610 84l-62 239-210-28q-17 26-35 50t-40 46l73 189-213 125-127-166q-60 13-122 15v-209q71 0 134-27t110-73 74-110 27-134q0-71-27-134t-74-110-110-74-134-27V467h5l79-178 238 63-27 203q53 34 99 80l186-71 124 213-166 127q6 28 9 56t4 57v10l185 82z" />
    </svg>
  ),
  displayName: 'AdminLLogoInverse32Icon',
});

export default AdminLLogoInverse32Icon;
